import "@/App.css";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Embed from "@/components/site/Embed";
import ConsultationPage from "@/pages/ConsultationPage";
import LegalPage from "@/pages/LegalPage";
import AreaCliente from "@/pages/AreaCliente";
import RedirectRiservata from "@/pages/RedirectRiservata";

function PartnerEmbed() {
  const { code } = useParams();
  return <Embed path={`/api/view/partner/${encodeURIComponent(code)}${window.location.search}`} title={`ZERAMI · ${code}`} />;
}

function AdvEmbed() {
  const { code } = useParams();
  return <Embed path={`/api/view/adv/${encodeURIComponent(code)}${window.location.search}`} title={`ZERAMI · ${code}`} />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Real ZERAMI landing served 1:1 via our proxy */}
          <Route path="/" element={<Embed path="/api/view/zerami" />} />
          <Route path="/partner/:code" element={<PartnerEmbed />} />
          <Route path="/adv/:code" element={<AdvEmbed />} />
          {/* Consultation lead form (forwards to ZERAMI backend) */}
          <Route path="/request-consultation" element={<ConsultationPage />} />
          {/* Dynamic legal pages (texts served from the ZERAMI admin) */}
          <Route path="/privacy-policy" element={<LegalPage doc="privacy-policy" />} />
          <Route path="/cookie-policy" element={<LegalPage doc="cookie-policy" />} />
          <Route path="/eula" element={<LegalPage doc="eula" />} />
          <Route path="/privacy-candidature" element={<LegalPage doc="privacy-candidature" />} />
          {/* Reserved areas (Fase 2). Provisional pages until the real areas ship. */}
          <Route path="/area-cliente/*" element={<AreaCliente />} />
          <Route path="/area-riservata/*" element={<RedirectRiservata />} />
          <Route path="/area-segnalatore/*" element={<RedirectRiservata />} />
          <Route path="*" element={<Embed path="/api/view/zerami" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
